export const RouteEnum = {
    DASHBOARD: "/",
    PRODUCT_RANGE: "/product-range",
    BRANDING: "/branding",
    SEARCH: "/search",
};
